import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Button from 'components/atoms/Button';
import { ImageFallbackStatic } from 'utils/ImageFallback';
import { VARIANT_LIST } from './index';
import styles from './styles.module.css';

export default function ConsultBtn({ className, onClick, variant = VARIANT_LIST.DETAIL, disabled = false }) {
  switch (variant) {
    case VARIANT_LIST.CART:
      return (
        <Button
          className={`${styles.consultBtn} ${className || ''}`}
          variant="contained"
          onClick={onClick}
          disabled={disabled}
          startIcon={
            <ImageFallbackStatic src={`${process.env.NEXT_PUBLIC_CDN_PREFIX || ''}/images/Dialog.png`} width={16} height={16} layout="fixed" />
          }
          fullWidth
        >
          Tư vấn sản phẩm
        </Button>
      );

    case VARIANT_LIST.LIST:
      return (
        <Button
          className={`${styles.consultBtn} ${styles.consultBtnList} ${className || ''}`}
          variant="contained"
          onClick={onClick}
          disabled={disabled}
          startIcon={
            <ImageFallbackStatic src={`${process.env.NEXT_PUBLIC_CDN_PREFIX || ''}/images/Dialog.png`} width={24} height={24} layout="fixed" />
          }
          endIcon={<ArrowForwardIcon style={{ fontSize: '1.2em' }} />}
          fullWidth
        >
          Tư vấn sản phẩm
        </Button>
      );

    case VARIANT_LIST.ICON:
      return (
        <Button
          className={`${styles.consultBtn} ${styles.consultBtnIcon} ${className || ''}`}
          variant="contained"
          onClick={onClick}
          disabled={disabled}
          title="Tư vấn sản phẩm"
          aria-label="Tư vấn sản phẩm"
        >
          <ImageFallbackStatic src={`${process.env.NEXT_PUBLIC_CDN_PREFIX || ''}/images/Dialog.png`} width={18} height={18} layout="fixed" />
        </Button>
      );

    case VARIANT_LIST.LIST_HORIZONTAL:
      return (
        <Button
          className={`${styles.consultBtn} ${className || ''}`}
          variant="contained"
          onClick={onClick}
          disabled={disabled}
          startIcon={
            <ImageFallbackStatic src={`${process.env.NEXT_PUBLIC_CDN_PREFIX || ''}/images/Dialog.png`} width={24} height={24} layout="fixed" />
          }
          fullWidth
        >
          Tư vấn sản phẩm
        </Button>
      );

    case VARIANT_LIST.DETAIL:
    default:
      return (
        <Button
          className={`${styles.consultBtn} ${className || ''}`}
          variant="contained"
          onClick={onClick}
          disabled={disabled}
          startIcon={
            <ImageFallbackStatic src={`${process.env.NEXT_PUBLIC_CDN_PREFIX || ''}/images/Dialog.png`} width={24} height={24} layout="fixed" />
          }
          endIcon={<ArrowForwardIcon style={{ fontSize: '1.2em' }} />}
          size="large"
          fullWidth
        >
          Tư vấn sản phẩm
        </Button>
      );
  }
}
